import { render, staticRenderFns } from "./CustomerCenter.vue?vue&type=template&id=57f5f0e8&scoped=true"
import script from "./CustomerCenter.vue?vue&type=script&lang=js"
export * from "./CustomerCenter.vue?vue&type=script&lang=js"
import style0 from "./CustomerCenter.vue?vue&type=style&index=0&id=57f5f0e8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57f5f0e8",
  null
  
)

export default component.exports